/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import can from 'can';
import DomEventsManager from 'scripts/dom-events-manager';
import deviceUtil from 'scripts/utils/device';

const scrollRightRailOffset = 50;

export const Latest = BaseControl.extend({
    $layout: null,
    $timeline: null,
    $rightRail: null,
    $window: null,
    layoutHeight: 0,
    layoutY: 0,
    timelineHeight: 0,
    rightRailHeight: 0,
    windowWidth: 0,
    windowHeight: 0,
    scrollY: 0,
    rightRailState: {
        isAtTop: false,
        isFixedAtTop: false,
        isFixedAtBottom: false,
        fixedOffset: 0,
    },

    init: function() {
        this._super();

        DomEventsManager.subscribe(this);
    },

    getElements() {
        this.$layout = this.$element.find('.l-frame-two-columns');
        this.$timeline = this.$element.find('.m-timeline');
        this.$rightRail = this.$element.find('.m-right-rail');
        this.$window = this.$(window);
    },

    getSizesAndOffsets() {
        this.scrollY = window.pageYOffset;
        this.layoutY = (this.$layout.offset() || {}).top || 0;
        this.layoutHeight = this.$layout.outerHeight(true);
        this.timelineHeight = this.$timeline.outerHeight(true);
        this.rightRailHeight = this.$rightRail.outerHeight(true);
        this.windowWidth = this.$window.width();
        this.windowHeight = this.$window.height();
    },

    isRightRailInRightColumn() {
        return this.windowWidth >= 1024;
    },

    updateRightRailState() {
        const isRightRailFitsViewport =
            this.rightRailHeight < this.windowHeight;

        this.rightRailState = {
            isAtTop: false,
            isFixedAtTop: false,
            isFixedAtBottom: false,
            fixedOffset: 0,
        };

        if (this.isRightRailInRightColumn()) {
            if (
                this.scrollY >= this.layoutY &&
                this.timelineHeight > this.rightRailHeight
            ) {
                this.rightRailState.isAtTop = isRightRailFitsViewport;

                if (
                    isRightRailFitsViewport &&
                    this.scrollY +
                        this.rightRailHeight +
                        scrollRightRailOffset >
                        this.layoutY + this.timelineHeight
                ) {
                    this.rightRailState.isAtTop = false;
                    this.rightRailState.isFixedAtBottom = true;
                    this.rightRailState.fixedOffset =
                        this.timelineHeight - this.rightRailHeight;
                }

                if (
                    !this.rightRailState.isAtTop &&
                    this.scrollY > this.rightRailHeight &&
                    !isRightRailFitsViewport
                ) {
                    if (this.scrollY > this.timelineHeight) {
                        this.rightRailState.isFixedAtBottom = true;
                        this.rightRailState.fixedOffset =
                            this.timelineHeight - this.rightRailHeight;
                    } else if (
                        this.scrollY + this.windowHeight >
                        this.rightRailHeight
                    ) {
                        this.rightRailState.isFixedAtTop = true;
                        this.rightRailState.fixedOffset = -Math.abs(
                            this.rightRailHeight - this.windowHeight,
                        );
                    }
                }
            }
        }
    },

    updateRightRailClasses() {
        this.$rightRail.toggleClass(
            'affix-top',
            this.rightRailState.isAtTop || this.rightRailState.isFixedAtTop,
        );
        this.$rightRail.toggleClass(
            'affix-bottom',
            this.rightRailState.isFixedAtBottom,
        );

        if (this.rightRailState.isAtTop) {
            this.$rightRail.css('top', scrollRightRailOffset + 'px');
        }

        if (
            this.rightRailState.isFixedAtTop ||
            this.rightRailState.isFixedAtBottom
        ) {
            this.$rightRail.css('top', this.rightRailState.fixedOffset + 'px');
        }
    },

    updateRightRail() {
        this.updateRightRailState();
        this.updateRightRailClasses();
    },

    onDocumentReady() {
        this.getElements();
        this.getSizesAndOffsets();
        this.updateRightRail();
    },

    onWindowScroll() {
        this.getSizesAndOffsets();
        this.updateRightRail();
    },
});
